import { throttle } from 'throttle-debounce'

// ScrollPosition
export default class ScrollPosition {
  constructor() {
    this.html = document.querySelector('html')
    this.lastScrollY = 0
    this.headerHidden = false
    this.isHeaderHideEnabled = true
    this.ticking = false
    this.scrollThreshold = 100
    /** 方向転換直後の微小な揺れでヘッダーを切り替えない（px） */
    this.directionThreshold = 12
    this.init()
  }

  init() {
    this.updateHeaderHideEnabled()

    window.addEventListener(
      'resize',
      throttle(100, () => {
        this.updateHeaderHideEnabled()
        this.onScroll()
      }),
      false,
    )
    window.addEventListener('scroll', () => this.requestTick(), { passive: true })
    this.onScroll()
  }

  updateHeaderHideEnabled() {
    const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches
    const isNarrow = window.innerWidth < 768
    this.isHeaderHideEnabled = !(isCoarsePointer || isNarrow)

    if (!this.isHeaderHideEnabled && this.headerHidden) {
      this.html.classList.remove('is-header-hide')
      this.headerHidden = false
    }
  }

  requestTick() {
    if (this.ticking) {
      return
    }
    this.ticking = true
    requestAnimationFrame(() => {
      this.ticking = false
      this.onScroll()
    })
  }

  onScroll() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop
    const delta = scrollY - this.lastScrollY

    if (scrollY > this.scrollThreshold) {
      if (!this.html.classList.contains('is-scrolled')) {
        this.html.classList.add('is-scrolled')
      }
    } else if (this.html.classList.contains('is-scrolled')) {
      this.html.classList.remove('is-scrolled')
    }

    if (this.isHeaderHideEnabled && Math.abs(delta) >= this.directionThreshold) {
      if (delta < 0 || scrollY <= this.scrollThreshold) {
        if (this.headerHidden) {
          this.html.classList.remove('is-header-hide')
          this.headerHidden = false
        }
      } else if (!this.headerHidden) {
        this.html.classList.add('is-header-hide')
        this.headerHidden = true
      }
    }

    this.lastScrollY = scrollY
  }
}
